// extracted by mini-css-extract-plugin
export default {"section":"FormSection_section__jrY2M","placeHolderShimmer":"FormSection_placeHolderShimmer__YaTl-"};